/** @odoo-module **/

export const session = odoo.__session_info__ || {};
delete odoo.__session_info__;
